<git-task-pullrequest *ngIf="(pullRequests$ | async).length > 0 && (isInstalled$ | async)" [taskPullRequests]="pullRequests$ | async" [assocRepoMap]="asscocRepoList$ | async"
  (removeItem)="onRemove($event)">
  <git-task-block-title [integrationName]="name" [title]="'Bitbucket Pull Requests'"></git-task-block-title>
</git-task-pullrequest>
